import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import ErrorScreen from "../components/ErrorScreen";
import { useUser } from "../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BetManagement = () => {
  const [bets, setBets] = useState([]);
    const [roleType, setRoleType] = useState("");
  const [loading, setLoading] = useState(true); // 로딩 상태 추가
  const [error, setError] = useState(null); // 에러 처리
    const [userList, setUserList] = useState([]);
      const { userInfo ,setUserInfo} = useUser();

  const [page, setPage] = useState(0); // 페이지 번호
  const [size, setSize] = useState(10); // 페이지 크기
  const [totalPages, setTotalPages] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedUser, setSelectedUser] = useState("");
  const [summary, setSummary] = useState({ totalPotAmount: 0, totalBuyInAmount: 0 });

  const [activeFilter, setActiveFilter] = useState(""); 

  const [searchUserId, setSearchUserId] = useState("");
const [searchRoomNumber, setSearchRoomNumber] = useState("");
const [searchGameName, setSearchGameName] = useState("");

const [sortField, setSortField] = useState("");
const [sortOrder, setSortOrder] = useState("asc");

const handleSort = (field) => {
  if (sortField === field) {
    // 같은 컬럼 클릭 시 asc → desc → 초기화
    const nextOrder = sortOrder === "asc" ? "desc" : sortOrder === "desc" ? "" : "asc";
    setSortOrder(nextOrder);
    if (nextOrder === "") {
      setSortField("");
    }
  } else {
    setSortField(field);
    setSortOrder("asc");
  }
};

  const formatDateTimeLocal = (date) => {
    const pad = (n) => n.toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  };


useEffect(() => {
  axios.get(`${API_BASE_URL}/bets/today-summary`, {
    headers: {
      'X-Frontend-Request': 'true',
    },
    params: {
      username: userInfo.username,                    // ✅ 로그인 관리자 아이디
      selectedUser: selectedUser || null,             // ✅ 선택된 유저
      adminType: roleType || null,                    // ✅ 관리자 계층

      searchUserId: searchUserId || null,             // 🔍 유저 ID 검색
      searchRoomNumber: searchRoomNumber || null,     // 🔍 룸 번호 검색
      searchGameName: searchGameName || null,         // 🔍 게임 이름 검색
    },
  })
  .then((res) => setSummary(res.data))
  .catch((err) => console.error("Summary fetch error:", err));
}, [
  selectedUser,
  roleType,
  searchUserId,
  searchRoomNumber,
  searchGameName,
  userInfo.username
]);

useEffect(() => {
  axios.get(`${API_BASE_URL}/bets`, {
    headers: {
      'X-Frontend-Request': 'true',
    },
    params: {
      page: page,
      size: size,
      start: startDate,
      end: endDate,
      username: userInfo.username,
      selectedUser: selectedUser === "" ? null : selectedUser,
      adminType: roleType === "" ? null : roleType,
      searchUserId: searchUserId === "" ? null : searchUserId,
      searchRoomNumber: searchRoomNumber === "" ? null : searchRoomNumber,
      searchGameName: searchGameName === "" ? null : searchGameName,
      sort: `${sortField},${sortOrder}`,
    },
  })
    .then((response) => {
      setBets(response.data.content);
      setTotalPages(response.data.totalPages);
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setLoading(false);
    });
}, [page, size, startDate, endDate, selectedUser, roleType, sortField, sortOrder, searchUserId, searchRoomNumber, searchGameName]);
     useEffect(() => {
    axios.get(`${API_BASE_URL}/admin/children`, {
       headers: {
           
           'X-Frontend-Request': 'true',
          },
      params: {
        username:userInfo.username,
        target:roleType
      },
    })
      .then((response) => {
        setUserList(response.data); // Page 객체라면 .content 접근 필요
        setSelectedUser(""); // 여기서 선택 초기화
      })
      .catch((error) => {
        setError(error.message); // 에러 발생 시 에러 메시지 상태에 저장
      }).finally(() => {
        setLoading(false);
      });
  }, [roleType]);  // 의존성도 같이 설정

const renderSortIcon = (field) => {
  if (sortField !== field) {
    return <FontAwesomeIcon icon="sort" style={{ width: "1rem" }} />;
  }
  return (
    <FontAwesomeIcon 
      icon={sortOrder === "asc" ? "caret-up" : "caret-down"}
      style={{ width: "1rem" }}
    />
  );
};


  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="loader"></div>
      </div>
    );
  }
  
  if (error) {
    return <ErrorScreen message={error} />;
  }

  return (
    <div id="container">
      <div className="container-inner">
        <h2>게임 배팅 내역</h2>
        <div className="bet-list">

                {/* ✅ 요약 박스 */}
          <div className="summary-box">
            <div className="summary-item">
              <span className="label">오늘 팟 금액 총합</span>
              <span className="value">{summary.totalPotAmount.toLocaleString()} 원</span>
            </div>

            <div className="summary-item">
              <span className="label">오늘 바이인 금액 총합</span>
              <span className="value">{summary.totalBuyInAmount.toLocaleString()} 원</span>
            </div>
          </div>

           <div className="search-sort-bar">
  <input
    type="text"
    placeholder="유저 ID"
    value={searchUserId}
    onChange={(e) => setSearchUserId(e.target.value)}
  />
  <input
    type="text"
    placeholder="방 번호"
    value={searchRoomNumber}
    onChange={(e) => setSearchRoomNumber(e.target.value)}
  />
  <input
    type="text"
    placeholder="게임 종류"
    value={searchGameName}
    onChange={(e) => setSearchGameName(e.target.value)}
  />
</div>


          <div className="filters between">

           


         <div className ="user-filters">
     <div className="role-tabs">
       {["전체", "부본사", "대리점"].map((role) => (
            <button
              key={role}
              className={roleType === (role === "전체" ? "" : role) ? "active" : ""}
              onClick={() => {
                setRoleType(role === "전체" ? "" : role);
                setSelectedUser("");
              }}
            >
              {role}
            </button>
          ))}
      </div>
        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)}>
          <option value="">-- 전체 보기 --</option>
          {userList.map((user) => (
            <option key={user.username} value={user.username}>
              {user.username}
            </option>
          ))}
        </select>
        </div>
     <div className="date-filters">

          <div className="date-buttons">

    <button
      className={activeFilter === "1hour" ? "active" : ""}
      onClick={() => {
        const oneHourAgo = new Date();
        oneHourAgo.setHours(oneHourAgo.getHours() - 1);
        setStartDate(formatDateTimeLocal(oneHourAgo));
        setEndDate('');
        setActiveFilter("1hour");
      }}
    >
      1시간 전
    </button>

    <button
      className={activeFilter === "6hour" ? "active" : ""}
      onClick={() => {
        const sixHoursAgo = new Date();
        sixHoursAgo.setHours(sixHoursAgo.getHours() - 6);
        setStartDate(formatDateTimeLocal(sixHoursAgo));
        setEndDate('');
        setActiveFilter("6hour");
      }}
    >
      6시간 전
    </button>
    <button
      className={activeFilter === "today" ? "active" : ""}
      onClick={() => {
        const now = new Date();
        const start = new Date(now.setHours(0, 0, 0, 0)); // 오늘 00:00:00
        const end = new Date();
        end.setHours(23, 59, 59, 999); // 오늘 23:59:59.999

        setStartDate(formatDateTimeLocal(start));
        setEndDate(formatDateTimeLocal(end));
        setActiveFilter("today");
      }}
    >
      오늘
    </button>

    <button
      className={activeFilter === "yesterday" ? "active" : ""}
      onClick={() => {
        const now = new Date();
        now.setDate(now.getDate() - 1);
        const start = new Date(now.setHours(0, 0, 0, 0)); // 어제 00:00:00
        const end = new Date(now);
        end.setHours(23, 59, 59, 999); // 어제 23:59:59.999

        setStartDate(formatDateTimeLocal(start));
        setEndDate(formatDateTimeLocal(end));
        setActiveFilter("yesterday");
      }}
    >
      어제
    </button>

    <button
      className={activeFilter === "all" ? "active" : ""}
      onClick={() => {
        setStartDate('');
        setEndDate('');
        setActiveFilter("all");
      }}
    >
      전체
    </button>

  </div>

  {/* 날짜 수동 입력 */}
  <div className="date-inputs">
    <input
      type="datetime-local"
      value={startDate}
      onChange={(e) => {
        setStartDate(e.target.value);
        setActiveFilter(""); // 수동입력 시 버튼 선택 해제
      }}
    />
    <input
      type="datetime-local"
      value={endDate}
      onChange={(e) => {
        setEndDate(e.target.value);
        setActiveFilter(""); // 수동입력 시 버튼 선택 해제
      }}
    />
  </div>
  </div>
          </div>
          <table>
            <thead>
             <tr>
            <th>유저 ID</th>
            <th>게임종류</th>
            <th>방번호</th>
            <th>진행한 핸드수</th>

            <th onClick={() => handleSort("betTime")} className="cursor-pointer">
              배팅 시간 <span className="sort-icon">{renderSortIcon("betTime")}</span>
            </th>

            <th>게임내역</th>

            <th onClick={() => handleSort("betAmount")} className="cursor-pointer">
              배팅 금액 <span className="sort-icon">{renderSortIcon("betAmount")}</span>
            </th>

            <th>팟금액</th>
            <th>레이크 (%)</th>

            <th onClick={() => handleSort("buyInAmount")} className="cursor-pointer">
              바이인 금액 <span className="sort-icon">{renderSortIcon("buyInAmount")}</span>
            </th>
          </tr>
            </thead>
            <tbody>
            {bets.length > 0 ? ( <>
            {bets.map((bet, index) => (
                <tr key={index}>
                  <td>{bet.user.username}</td>
                  <td>{bet.gameApi.game.gameName}</td>
                  <td>{bet.roomNumber}</td>
                  <td>{bet.handsPlayed} 회</td>
                  <td>{bet.betTime.substring(0, 19).replace('T', ' ')}</td>
                  <td>{bet.gameHistory}</td>
                  <td>{bet.betAmount.toLocaleString()} 원</td>
                  <td>{bet.potAmount.toLocaleString()} 원</td>
                  <td>{bet.rake} %</td>
                  <td>{bet.buyInAmount.toLocaleString()} 원</td>
                </tr>
              ))}</>):(<></>)}
            </tbody>
          </table>

         

          {bets.length > 0 ? ( <> 
            <div className="pagination">
                {/* 이전 페이지 버튼 */}
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>
                  ◁
                </button>

                {totalPages > 0 && (
                  <>
                    {/* 현재 페이지 기준 ±2 페이지 범위 계산 */}
                    {Array.from({ length: totalPages }, (_, i) => i)
                      .filter(i => {
                        // 페이지 범위 조정: 항상 5개의 버튼을 보여주기
                        if (page <= 2) return i <= 4; // 첫 페이지일 때, 1~5
                        if (page >= totalPages - 3) return i >= totalPages - 5; // 마지막 페이지일 때, 마지막 5개
                        return i >= page - 2 && i <= page + 2; // 그 외에는 ±2 페이지
                      })
                      .map(i => (
                        <button
                          key={i}
                          className={i === page ? "active" : ""}
                          onClick={() => setPage(i)}
                        >
                          {i + 1}
                        </button>
                      ))}
                  </>
                )}

                {/* 다음 페이지 버튼 */}
                <button disabled={page === totalPages - 1} onClick={() => setPage(page + 1)}>
                  ▷
                </button>
              </div>
        </>): (
            <div className="empty-state">
              <i className="fa-solid fa-exclamation-circle"></i>
              <p className="title">내역이 존재하지 않습니다</p>
            </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default BetManagement;
